import React from 'react'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import _ from 'lodash'
import styled from '@emotion/styled'
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { useMainFrameDispatch, useMainFrameState } from '../MainFrame'
import { ACTION_LEFT_DRAWER_CLOSE, ACTION_RIGHT_DRAWER_CLOSE, ACTION_RIGHT_DRAWER_OPEN } from '../constants'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const SwipeableDrawerProvider = props => {
    const app = useSelector(state => state.currentUser)
    const { isRightDrawer, isLeftDrawer, RightDrawerJsx, rightDrawerWidth } = useMainFrameState();
    const mainDispatch = useMainFrameDispatch();

    const OpenDrawer = event => {
        mainDispatch({ type: ACTION_RIGHT_DRAWER_OPEN })
    }

    const CloseDrawer = event => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return
        }
        mainDispatch({ type: ACTION_RIGHT_DRAWER_CLOSE })
        mainDispatch({ type: ACTION_LEFT_DRAWER_CLOSE })
    }

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        margin: 0,
        padding: 0,
        justifyContent: isRightDrawer ? 'flex-start' : 'flex-end',
    }));


    const ResponsiveDrawer = styled(props => {
        return (
            <SwipeableDrawer {...props}>
                <DrawerHeader>
                    <IconButton onClick={CloseDrawer}>
                        {isRightDrawer ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </DrawerHeader>
                <Box style={{ padding: props?.padding || '0px 10px' }}>
                    {RightDrawerJsx}
                </Box>
            </SwipeableDrawer>
        )
    })(({ theme }) => ({
        [theme.breakpoints.up('md')]: {
            width: rightDrawerWidth || '50%',
            '& .MuiDrawer-paper': {
                width: rightDrawerWidth || '50%',
                background: app?.theme == 'light' && '#fff',
            },
        },
        [theme.breakpoints.down('md')]: {
            width: '60%',
            '& .MuiDrawer-paper': {
                width: '60%',
                background: app?.theme == 'light' && '#fff',
            },
        },
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            '& .MuiDrawer-paper': {
                width: '95%',
                background: app?.theme == 'light' && '#fff',
            },
        },
        '& .MuiDrawer-paper': {
            borderRadius: '12px 0px 0px 12px'
        }
    }))

    return (
        <>
            <ResponsiveDrawer
                anchor={isRightDrawer ? 'right' : 'left'}
                open={isRightDrawer || isLeftDrawer}
                onClose={CloseDrawer}
                disableSwipeToOpen={!isRightDrawer && !isLeftDrawer}
                {...props}
            />
        </>
    )
}

export default SwipeableDrawerProvider
